module.exports = __webpack_public_path__ + "static/media/logo-symbol-01-1024-white.37ab532c.jpg";